<template>
    <section id="Verse" class="Prayer white-text">
        <div class="row container">
            <div class="col s12 m12 l10 offset-l1 center">
                <p>
                    In Christ we, though many, form one body, and each member belongs to all the others.
                    <span>1 Corintians 12: 12</span>
                </p>
            </div>
        </div>
    </section>
</template>

<script>   
    export default {
        name: 'Verse',
    }
</script>

<style scoped>
    section {
        padding: 8.5rem 0 6.5rem 0;
        background: rgba(9,12,13, 1);
        background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(9,12,13, 1)), to(rgba(63, 66, 67, 1)));
        background-image: linear-gradient(rgba(9,12,13, 1), rgba(63, 66, 67, 1));
        background-size: cover;
        min-height: 300px;
    }
    p {
        font-size: 3rem;
        line-height: 1.25;
        font-family: NewhouseDTCond-ExtBold;
    }

    p span {
        display: block;
        padding-top: 10px;
        font-size: 2rem;
        color: rgba(91,124,138, 1);
    }
</style>